export const FEATURED_BOOKS = [
    {
        src: "/books/where_sleeping_girls_lie_250x250.jpg",
        title: "Where Sleeping Girls Lie",
        author: "Faridah Àbíké-Íyímídé",
        vibe: "Dark academia · Mystery",
        summary: "A new student at an elite boarding school investigates the disappearance of her roommate — and uncovers the rot at the heart of its hallowed halls.",
    },
    {
        src: "/books/the_kiss_countdown_250x250.jpg",
        title: "The Kiss Countdown",
        author: "Etta Easton",
        vibe: "Contemporary romance",
        summary: "A struggling event planner agrees to fake-date a charming astronaut for the three months before his space mission. Three months. Real feelings.",
    },
    {
        src: "/books/she_who_became_the_sun_250x250.jpg",
        title: "She Who Became the Sun",
        author: "Shelley Parker-Chan",
        vibe: "Epic fantasy",
        summary: "In 14th-century China, a peasant girl claims her dead brother's destiny of greatness — and rises through war, disguise, and ambition to remake her world.",
    },
    {
        src: "/books/so_let_them_burn_250x250.jpg",
        title: "So Let Them Burn",
        author: "Kamilah Cole",
        vibe: "YA fantasy · Dragons",
        summary: "Five years after the gods chose her to save the islands, a young hero's sister bonds with an enemy dragon — forcing her to choose between family and her people.",
    },
    {
        src: "/books/black_girl_power_250x250.jpg",
        title: "Black Girl Power",
        author: "Ed. Leah Johnson",
        vibe: "Anthology · YA",
        summary: "Fifteen short stories from leading Black women writers — joy, struggle, magic, and triumph, all in celebration of Black girlhood.",
    },
    {
        src: "/books/the_perfect_ruin_250x250.jpg",
        title: "The Perfect Ruin",
        author: "Shanora Williams",
        vibe: "Thriller · Suspense",
        summary: "A sun-soaked thriller of revenge, secrets, and a woman whose carefully built life is about to come apart at the seams.",
    },
    {
        src: "/books/pet_250x250.jpg",
        title: "Pet",
        author: "Akwaeke Emezi",
        vibe: "YA · Literary",
        summary: "In a town that swears all monsters are gone, Jam and a creature called Pet hunt the one nobody wants to admit is still hiding here.",
    },
    {
        src: "/books/house_in_the_cerulean_sea_250x250.jpg",
        title: "The House in the Cerulean Sea",
        author: "TJ Klune",
        vibe: "Cozy fantasy",
        summary: "A by-the-book caseworker is sent to a remote island orphanage of magical children — and quietly falls in love with the strange, gentle family he finds.",
    },
    {
        src: "/books/wash_day_diaries_250x250.jpg",
        title: "Wash Day Diaries",
        author: "J. Rowser & R. Smith",
        vibe: "Graphic novel",
        summary: "Four Bronx best friends, four chapters, four wash days. An intimate graphic novel about Black womanhood, friendship, and tender self-care.",
    },
    {
        src: "/books/black_250x250.jpg",
        title: "BLACK",
        author: "Osajyefo · Smith",
        vibe: "Graphic novel · Dystopia",
        summary: "In a world where only Black people have superpowers, a young man caught at the wrong place must decide what to do with the truth — and who to trust.",
    },
    {
        src: "/books/legendborn_250x250.jpg",
        title: "Legendborn",
        author: "Tracy Deonn",
        vibe: "YA fantasy · Book 1",
        summary: "After a magical attack at her university, a grieving Black teen uncovers a secret society of Arthurian descendants — and her own ancestral powers.",
    },
    {
        src: "/books/bloodmarked_250x250.jpg",
        title: "Bloodmarked",
        author: "Tracy Deonn",
        vibe: "YA fantasy · Book 2",
        summary: "Bree confronts the cost of her bloodline, the loyalty of her allies, and what it really means to wield ancestral magic in a war that won't wait.",
    },
    {
        src: "/books/oathbound_250x250.jpg",
        title: "Oathbound",
        author: "Tracy Deonn",
        vibe: "YA fantasy · Book 3",
        summary: "The Legendborn Cycle hurtles toward its reckoning — Bree pushes deeper into power, betrayal, and the legacy that's been hers all along.",
    },
    {
        src: "/books/black_sun_250x250.jpg",
        title: "Black Sun",
        author: "Rebecca Roanhorse",
        vibe: "Epic fantasy · Hugo winner",
        summary: "In a Mesoamerican-inspired world, a blind man with a dark prophecy sails toward a holy city on the eve of an eclipse that will change everything.",
    },
    {
        src: "/books/black_sands_250x250.jpg",
        title: "Black Sands: The Seven Kingdoms",
        author: "Godoy · Lenormand",
        vibe: "Graphic novel · Mythic",
        summary: "Four young heroes from a fantasy version of ancient Egypt are pulled into the warring Seven Kingdoms — a vibrant Afrofuturist epic.",
    },
    {
        src: "/books/a_language_of_dragons_250x250.jpg",
        title: "A Language of Dragons",
        author: "S.F. Williamson",
        vibe: "Fantasy · Linguistics",
        summary: "In an alt-1923 London where dragons walk among humans, a young codebreaker is recruited to decode a secret dragon dialect that could ignite a war.",
    },
    {
        src: "/books/these_heathens_250x250.jpg",
        title: "These Heathens",
        author: "Mia McKenzie",
        vibe: "Historical · Sapphic",
        summary: "1960 Atlanta: a poor Black teen travels into the heart of the civil rights movement with a fierce mentor — and a sapphic awakening she can't undo.",
    },
    {
        src: "/books/the_deep_250x250.jpg",
        title: "The Deep",
        author: "Rivers Solomon",
        vibe: "Speculative · Historical",
        summary: "Descendants of pregnant African women thrown from slave ships live as water-breathers in the deep — and one young historian must hold all their memories.",
    },
    {
        src: "/books/skin_of_the_sea_250x250.jpg",
        title: "Skin of the Sea",
        author: "Natasha Bowen",
        vibe: "Mythic fantasy · Mami Wata",
        summary: "A Mami Wata sworn to ferry drowned souls saves a living boy from a slave ship — breaking divine law and setting off a West African ocean epic.",
    },
    {
        src: "/books/the_black_tides_of_heaven_250x250.jpg",
        title: "The Black Tides of Heaven",
        author: "Neon Yang",
        vibe: "Silkpunk fantasy",
        summary: "Twin children of a ruthless empress are gifted to a monastery as collateral — and grow into rebels, prophets, and lovers in a world torn by power.",
    },
    {
        src: "/books/fourth_wing_250x250.jpg",
        title: "Fourth Wing",
        author: "Rebecca Yarros",
        vibe: "Romantasy · Dragons",
        summary: "Forced into a deadly dragon-rider academy where most cadets don't survive year one, a fragile scholar must outwit murderous classmates — and bond with a dragon.",
    },
    {
        src: "/books/brooms_250x250.jpg",
        title: "Brooms",
        author: "Walls & DuVall",
        vibe: "Graphic novel · Witches",
        summary: "1930s Mississippi: five queer kids of color race brooms in an underground witch league for prize money, freedom, and the future they want.",
    },
    {
        src: "/books/light_from_uncommon_stars_250x250.jpg",
        title: "Light From Uncommon Stars",
        author: "Ryka Aoki",
        vibe: "Cozy sci-fi",
        summary: "A trans runaway, a violin teacher who owes seven souls to a demon, and an alien donut-shop owner find unlikely family in suburban California.",
    },
    {
        src: "/books/malika_warrior_queen_250x250.jpg",
        title: "Malika: Warrior Queen",
        author: "Roye Okupe",
        vibe: "Graphic novel · Epic",
        summary: "In medieval West Africa, a young queen defends her kingdom from invaders, sorcerers, and her own court — a lush, sweeping graphic novel epic.",
    },
    {
        src: "/books/godkiller_250x250.jpg",
        title: "Godkiller",
        author: "Hannah Kaner",
        vibe: "Dark fantasy",
        summary: "In a kingdom where gods are outlawed, a battered godkiller, a bonded child-god, and a knight on the run forge a doomed alliance.",
    },
    {
        src: "/books/all_the_sinners_bleed_250x250.jpg",
        title: "All the Sinners Bleed",
        author: "S.A. Cosby",
        vibe: "Southern thriller",
        summary: "The first Black sheriff of a small Virginia town hunts a serial killer hiding behind the town's polite — and quietly racist — veneer.",
    },
    {
        src: "/books/black_water_sister_250x250.jpg",
        title: "Black Water Sister",
        author: "Zen Cho",
        vibe: "Urban fantasy",
        summary: "A Malaysian-American woman returns to Penang and finds her dead grandmother's vengeful ghost has very specific plans — including stopping a god.",
    },
    {
        src: "/books/from_from_250x250.jpg",
        title: "From From",
        author: "Monica Youn",
        vibe: "Poetry · Diaspora",
        summary: "A piercing collection on diaspora, race, and the question never asked of a white person — where are you really from?",
    },
    {
        src: "/books/monsters_we_make_250x250.jpg",
        title: "Monsters We Make",
        author: "Kali White",
        vibe: "Mystery · Suspense",
        summary: "Two missing-boy cases haunt a small Iowa town in 1984 — and a paperboy's older sister chases the truth through suburban silence.",
    },
    {
        src: "/books/bookblend_reading_journal_250x250.jpg",
        title: "BookBlend Reading Journal",
        author: "BookBlend",
        vibe: "Bag exclusive",
        summary: "Your reading life, beautifully kept. Included in every BookBlend bag — prompts, trackers, and pages waiting for your favorite lines.",
    },
];
